import { render, staticRenderFns } from "./OtpModalExternal.vue?vue&type=template&id=3a490d44&"
import script from "./OtpModalExternal.vue?vue&type=script&lang=js&"
export * from "./OtpModalExternal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a490d44')) {
      api.createRecord('3a490d44', component.options)
    } else {
      api.reload('3a490d44', component.options)
    }
    module.hot.accept("./OtpModalExternal.vue?vue&type=template&id=3a490d44&", function () {
      api.rerender('3a490d44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/OtpModalExternal.vue"
export default component.exports